import { render, staticRenderFns } from "./PieChartConfig.vue?vue&type=template&id=4981742a"
import script from "./PieChartConfig.vue?vue&type=script&lang=js"
export * from "./PieChartConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4981742a')) {
      api.createRecord('4981742a', component.options)
    } else {
      api.reload('4981742a', component.options)
    }
    module.hot.accept("./PieChartConfig.vue?vue&type=template&id=4981742a", function () {
      api.rerender('4981742a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/PieChartConfig.vue"
export default component.exports